import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://ecomback-bice.vercel.app';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to handle FormData (multipart/form-data)
api.interceptors.request.use((config) => {
  // If the data is FormData, let the browser set the Content-Type header
  // This allows it to set the boundary parameter automatically
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

// Products
export const getAllProducts = () => api.get('/getallproduct');
export const getProductById = (id) => api.get(`/getproduct/${id}`);
export const getProductsByCategory = (id) => api.get(`/getallproductById/${id}`);
export const getOfferProducts = () => api.get('/offerProducts');

// Categories
export const getCategories = () => api.get('/categories');
export const getHomeCategories = () => api.get('/homeCategories');
export const getCategoryById = (id) => api.get(`/category/${id}`);
export const getSubcategories = () => api.get('/subcategories');

// Auth
export const login = (data) => api.post('/Login', data);
export const register = (data) => api.post('/Register', data);
export const sendOTP = (data) => api.post('/sendOTP', data);

// User
export const getUserAddress = (userId) => api.get(`/getAddress/${userId}`);
export const updateUserProfile = (data) => api.post('/updateProfile', data);

// Orders
export const placeOrder = (data) => api.post('/Order/Placed', data);
export const getUserOrders = (userId) => api.get(`/Orders/${userId}`);
export const updateOrderStatus = (data) => api.post('/OrderUpdateStatus', data);

// Addresses
export const addAddress = (userId, data) => api.post(`/address/${userId}`, data);
export const updateAddress = (userId, addressId, data) => api.put(`/address/${userId}/${addressId}`, data);
export const deleteAddress = (userId, addressId) => api.delete(`/address/${userId}/${addressId}`);
export const setDefaultAddress = (userId, addressId) => api.put(`/address/${userId}/${addressId}/default`);

// Wishlist
export const getWishlist = (userId) => api.get(`/wishlist/${userId}`);
export const addToWishlist = (data) => api.post('/wishlist/add', data);
export const removeFromWishlist = (data) => api.post('/wishlist/remove', data);

export default api;
